import { render } from "./BarmanCocktail.vue?vue&type=template&id=a35c62f0&scoped=true"
import script from "./BarmanCocktail.vue?vue&type=script&lang=js"
export * from "./BarmanCocktail.vue?vue&type=script&lang=js"

import "./BarmanCocktail.vue?vue&type=style&index=0&id=a35c62f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a35c62f0"]])

export default __exports__